import getValidProperties from "./getValidProperties";
import type { Property } from "entities/Action";

function getHeadersCount(
  actionHeaders?: Property[],
  datasourceHeaders?: Property[],
  autoGeneratedActionHeaders?: Property[],
): number {
  const validActionHeaders = getValidProperties(actionHeaders);
  const validDatasourceHeaders = getValidProperties(datasourceHeaders);
  const validAutoGeneratedHeaders = getValidProperties(
    autoGeneratedActionHeaders,
  );

  return (
    validActionHeaders.length +
    validDatasourceHeaders.length +
    validAutoGeneratedHeaders.length
  );
}

export default getHeadersCount;
